(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-bag-catalog"] && !Shopify.designMode) return;
  try {
    
function initBagCatalog(root) {
  if (root.dataset.ready) return;
  const controls = root.querySelector('[data-bag-filters]');
  if (!controls) return;
  root.dataset.ready = 'true';
  controls.hidden = false;
  const cards = [...root.querySelectorAll('[data-bag-card]')];
  const buttons = [...root.querySelectorAll('[data-bag-season]')];
  const model = root.querySelector('[data-bag-model]');
  const fabric = root.querySelector('[data-bag-fabric]');
  let season = new URLSearchParams(location.hash.slice(1)).get('season') || '';
  if (!buttons.some(button => button.dataset.bagSeason === season)) season = '';
  function update() {
    let count = 0;
    cards.forEach(card => {
      const visible = (!season || card.dataset.season === season) && (!model.value || card.dataset.model === model.value) && (!fabric.value || card.dataset.fabric === fabric.value);
      card.hidden = !visible;
      if (visible) count += 1;
    });
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bagSeason === season)));
    root.querySelector('[data-bag-count]').textContent = count + ' ' + root.querySelector('[data-bag-count-label]').textContent;
    root.querySelector('[data-bag-empty]').hidden = count !== 0;
  }
  buttons.forEach(button => button.addEventListener('click', () => {
    season = button.dataset.bagSeason;
    const url = new URL(location.href);
    url.hash = season ? 'season=' + encodeURIComponent(season) : '';
    history.replaceState(null, '', url);
    update();
  }));
  model.addEventListener('change', update);
  fabric.addEventListener('change', update);
  update();
}
document.querySelectorAll('[data-bag-catalog]').forEach(initBagCatalog);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bag-catalog]').forEach(initBagCatalog));

  } catch(e) { console.error(e); }
})();
})();
